<template>
  <div class="form-group theme-login-form-group">
    <label
      :for="`input-field-${_uid}`"
      class="theme-form-label">País<template v-if="required">*</template></label>
    <select
      :id="`input-field-${_uid}`"
      :name="name"
      v-model="modelField"
      v-validate="required ? validate : ''"
      @change="$emit('update:field', $event.target.value)"
      :class="{ 'alert-danger': submitted && errors.has(name) }"
      class="form-control">
      <option value="">Selecione um país</option>
      <option
        v-for="(country, index) in countries"
        :key="`personal-combo-option-country-${index}`"
        :value="country.id"
        :selected="country.id === field">
        {{ country.name }}
      </option>
    </select>
    <span class="theme-form-error-message">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  inject: [ '$validator' ],
  props: [
    'name',
    'submitted',
    'required',
    'validate',
    'field'
  ],
  computed: {
    ...mapState(['countries'])
  },
  data () {
    return {
      modelField: '',
      modelValidate: ''
    }
  },
  watch: {
    field (data) {
      this.modelField = data
    }
  }
}
</script>
